import {
  Autocomplete,
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  TableContainer,
  TextField,
} from '@mui/material'
import * as React from 'react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { protocolCols } from './ProtocolCols'
import PageSection from '../../../Constants&Theme/PageSection'
import { useFilteredProtocols } from './ProtocolFns'
import { stackGap } from '../../../Constants&Theme/Spacing'
import { appBar } from '../../../garvan-react/Constants/StyleConstants'

function Protocols() {
  const navigate = useNavigate()

  const [filter, setFilter] = useState(true)

  const protocolQuery = useFilteredProtocols(true, filter)

  return (
    <Box
      sx={{
        maxWidth: 'md',
        width: 1,
      }}
    >
      <PageSection title={'Protocols'}>
        <Stack
          direction={'row'}
          gap={stackGap.row}
          width={1}
          sx={{ mb: 2 }}
        >
          <Autocomplete
            fullWidth
            onChange={(event: any, newValue: any) =>
              navigate({
                pathname: '/stuart/study',
                search: '?protocol_id=' + newValue?.value,
              })
            }
            options={
              protocolQuery?.data ?
                protocolQuery.data.map((item) => ({
                  value: item.ProtocolID,
                  label: item.EthicsNumber,
                }))
              : []
            }
            renderInput={(params: any) => (
              <TextField
                {...params}
                fullWidth
                label="Protocol"
                placeholder={'Search...'}
              />
            )}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={filter}
                onChange={(e) => setFilter(e.target.checked)}
                color={'primary'}
              />
            }
            label="Filter Garvan"
            labelPlacement="start"
          />
        </Stack>
        <TableContainer
          sx={{
            maxWidth: 'xl',
            width: 1,
            height: `calc(100vh - ${appBar}px - 300px)`,
          }}
        >
          <DataGridPro
            getRowId={(row) => row.ProtocolID}
            rows={protocolQuery.data}
            columns={protocolCols}
            loading={protocolQuery.isLoading}
            onRowClick={({ row }) =>
              navigate({
                pathname: '/stuart/study',
                search: '?protocol_id=' + row.ProtocolID,
              })
            }
          />
        </TableContainer>
      </PageSection>
    </Box>
  )
}

export default Protocols
